import {BASE_URL, HandleErrorResponse} from "./common";

export interface CaseValidationResponseForJIT {
    IsValid: boolean;
    Subject: string; // the change case subject as provided by GUS, will be displayed if the case is valid
    Error: string; // for any error messages that must be displayed on the frontend
}

export const fetchChangeCaseStatusForJIT = async (caseId: string, accountId: string): Promise<CaseValidationResponseForJIT> => {
    const endpoint = `${BASE_URL}/validations/change-case/${caseId}?accountID=${accountId}`;

    return await fetchCaseStatusForJIT(endpoint);
}

export const fetchIncidentStatusForJIT = async (caseId: string, accountId: string): Promise<CaseValidationResponseForJIT> => {
    const endpoint = `${BASE_URL}/validations/incident/${caseId}?accountID=${accountId}`;

    return await fetchCaseStatusForJIT(endpoint);
}

async function fetchCaseStatusForJIT(endpoint: string): Promise<CaseValidationResponseForJIT> {
    try {
        const response = await fetch(endpoint, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            }
        });

        if (!response.ok) {
            await HandleErrorResponse(response);
        }

        return await response.json();
    } catch (error) {
        console.error("Error fetching reason data:", error);
        throw error;
    }
}
